import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-inline-edit',
  templateUrl: './inline-edit.component.html',
  styleUrls: ['./inline-edit.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InlineEditComponent),
      multi: true
    }
  ]
})
export class InlineEditComponent implements ControlValueAccessor {
  // Ahora soporta 4 tipos de inputs
  @Input() type: 'text' | 'textarea' | 'date' | 'ngselect' | 'select' | 'boolean' = 'text';
  @Input() placeholder: string = '';
  @Input() inputClass: string = '';
  @Input() modoEditar: boolean = false;
  
  // Array de opciones para cuando el tipo sea 'select'
  // Puede ser un array de strings ['Opción 1', 'Opción 2'] o de objetos
  @Input() options: any[] = []; 

  value: any = ''; // Cambiado a 'any' para soportar booleanos
  editando: boolean = false;
  valorTemporal: any = '';

  onChange: any = () => {};
  onTouch: any = () => {};

  private ultimoClick: number = 0;

  activarEdicion() {
    if (!this.modoEditar) return;

    const ahora = Date.now();
    const TIEMPO_DOBLE_CLICK = 1000; // Milisegundos máximos entre clicks

    // Si el tiempo entre el click actual y el anterior es menor a 300ms, es un doble click
    if (ahora - this.ultimoClick < TIEMPO_DOBLE_CLICK) {
      
      // Lógica original de tu componente:
      if (this.type === 'boolean') {
        this.value = !this.value;
        this.onChange(this.value);
        return;
      }
      
      this.valorTemporal = this.value;
      this.editando = true;
    }

    // Guardamos el momento de este click para el siguiente intento
    this.ultimoClick = ahora;
  }

  guardarCambios() {
    this.editando = false;
    
    // Validamos cambios según el tipo de dato
    const nuevoValor = typeof this.valorTemporal === 'string' 
      ? this.valorTemporal.trim() 
      : this.valorTemporal;

    if (nuevoValor !== this.value) {
      this.value = nuevoValor;
      this.onChange(this.value);
    }
  }

  writeValue(value: any): void { this.value = value; }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouch = fn; }
}